module.exports = __webpack_public_path__ + "assets/048a7935ca4ac9630454cae4588d6c2f.png";